import { Component, OnInit } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { map, switchMap } from "rxjs/operators";
import { UserFacadeService } from "src/app/core/facades/userfacade/userfacade.service";
import { ModalService } from "src/app/core/modalservice/modal.service";
import { TranslatorService } from "src/app/core/translator/translator.service";
import { RoleType } from "src/app/core/_models/role";
import { User } from "src/app/core/_models/user";
import { NgIf, NgFor } from "@angular/common";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatSelect, MatSelectChange } from "@angular/material/select";
import { MatOption } from "@angular/material/core";
import { TranslatePipe } from "@ngx-translate/core";
import { DatetimeFormatService } from "src/app/core/datetime-format-service/datetime-format.service";

@Component({
  selector: "app-userprofile",
  templateUrl: "./userprofile.component.html",
  styleUrls: ["./userprofile.component.scss"],
  imports: [
    NgIf,
    MatProgressSpinner,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    NgFor,
    MatOption,
    TranslatePipe,
  ],
})
export class UserprofileComponent implements OnInit {
  public isLoadingResults = false;

  public userForm: UntypedFormGroup;
  public user: User;
  public langs;
  locales: { code: string; displayName: string }[] = [
    { code: "en-US", displayName: "en-US (US): MM/dd/yyyy, h:mm AM/PM" },
    { code: "en-GB", displayName: "en-GB (UK): dd/MM/yyyy, HH:mm" },
    { code: "de-DE", displayName: "de-DE (Germany): MM.dd.yyyy, HH:mm" },
  ];
  constructor(
    private formBuilder: UntypedFormBuilder,
    private userFacadeService: UserFacadeService,
    private translator: TranslatorService,
    private modalService: ModalService,
    public dateTimeFormatService: DatetimeFormatService,
  ) {
    this.user = this.userFacadeService.user.getValue();

    this.langs = this.translator.availablelangs;
  }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      firstname: [this.user.firstname],
      lastname: [this.user.lastname, Validators.compose([Validators.required])],
      email: [this.user.email, [Validators.email]],
      language: { value: this.user.language },
      dateTimeFormat: { value: this.user.dateTimeFormat || "en-US" },
    });

    this.userForm.controls.language.patchValue(this.user.language);
    this.userForm.controls.dateTimeFormat.patchValue(this.user.dateTimeFormat);
    if (this.user.roles.includes(RoleType.GlobalAdmin || RoleType.HXAMaster)) {
      this.userForm.controls.email.disable();
    }
  }

  updateUser() {
    if (this.userForm.valid) {
      Object.assign(this.user, this.userForm.value);
      this.userFacadeService
        .updateUser(this.user.id, this.user)
        .pipe(
          switchMap(() => {
            return this.userFacadeService.getOrganisationUser().pipe(
              map((user) => {
                this.translator.useLanguage(user.language);
                this.userForm.patchValue(user);
              }),
            );
          }),
        )
        .subscribe(
          () => this.modalService.successModal(),
          (err) => this.modalService.errorModal(),
        );
    }
  }
  changeDateTimeFormat(event) {
    const selectedFormat = event.value;
    this.dateTimeFormatService.selectedDateTimeFormat$.next(selectedFormat);
    this.dateTimeFormatService.saveToStorage();

    this.userForm.patchValue({
      dateTimeFormat: selectedFormat,
    });
  }
  changeLanguage(event: MatSelectChange) {
    this.userForm.get("language").setValue(event.value);
    const selectedLang = event.value;
    let matchingLocale = selectedLang;
    if (selectedLang === "en") {
      matchingLocale = "en-US";
    } else if (selectedLang === "de") {
      matchingLocale = "de-DE";
    }
    if (this.locales.some((locale) => locale.code === matchingLocale)) {
      this.userForm.get("dateTimeFormat").setValue(event.value);
      this.changeDateTimeFormat({ value: matchingLocale });
    }
  }
}
